export default function ReturnToOriginButton({ url }) {
    return (
        <a href={url || process.env.REACT_APP_RETURN_URL} className="btn btn-brand btn-wide">
            <span>Return to Home</span>
        </a>
    );
}
